import { PiXThin } from 'react-icons/pi';
import { Icon, useToast } from '@chakra-ui/react';
import React from 'react';
import { User } from '@/types/core/User';
import ButtonWithConfirmTooltip from '@components/app/ButtonWithConfirmTooltip';
import { dropColleague } from '@/api/user';

export default function RemoveColleagueRelationShip({
  colleague,
  onSubmitEnd,
}: {
  colleague: User;
  onSubmitEnd?: () => void;
}) {
  const toast = useToast();

  return (
    <>
      <ButtonWithConfirmTooltip
        background={'none'}
        variant={'outline'}
        size={'xs'}
        padding={'0'}
        borderColor={'transparent'}
        _hover={{ background: 'none' }}
        confirmTitle={'Ne plus être collègue'}
        confirmMessage={
          'Êtes-vous sûr de ne plus vouloir être collègue avec cette personne ?'
        }
        onClickConfirm={async () => {
          try {
            const response = await dropColleague(colleague.id);
            if (response.ok) {
              toast({
                title: `${colleague.displayName} a été retiré de la liste de vos collègues`,
                status: 'success',
                duration: 5000,
                isClosable: true,
              });

              if (onSubmitEnd) {
                onSubmitEnd();
              }
            } else {
              throw new Error();
            }
          } catch (err) {
            toast({
              title: 'Une erreur est survenue',
              status: 'error',
              duration: 5000,
              isClosable: true,
            });
          }
        }}
      >
        <Icon
          as={PiXThin}
          color="brand.100"
          boxSize={6}
          cursor="pointer"
          _hover={{ color: 'danger.100' }}
        />
      </ButtonWithConfirmTooltip>
    </>
  );
}
